export default __webpack_public_path__ + "static/media/chef_icon.59bd6cc3.png";